const FULL = {
  circleR: 29,
  circleWidth: 2,
  realized: 'M13 43 L20 37 L26 40 L33 30',
  realizedWidth: 3.4,
  forecast: 'M33 30 L50 19',
  forecastWidth: 3,
  forecastDash: '3.2 4',
  dot: true,
}

const SHORT = {
  circleR: 28,
  circleWidth: 3.5,
  realized: 'M14 42 L21 36 L27 39 L33 31',
  realizedWidth: 5,
  forecast: 'M42 26 L51 20.5',
  forecastWidth: 5,
  forecastDash: null,
  dot: false,
}

export function Mark({ variant = 'auto', size = 32, className = '', title = 'Finance Prévision' }) {
  const mark = variant === 'short' || (variant === 'auto' && size <= 40) ? SHORT : FULL
  const labelled = Boolean(title)

  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      fill="none"
      className={className}
      role={labelled ? 'img' : 'presentation'}
      aria-label={labelled ? title : undefined}
      aria-hidden={labelled ? undefined : true}
    >
      <circle
        cx="32"
        cy="32"
        r={mark.circleR}
        stroke="currentColor"
        strokeWidth={mark.circleWidth}
      />
      <path
        d={mark.realized}
        stroke="currentColor"
        strokeWidth={mark.realizedWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d={mark.forecast}
        stroke="currentColor"
        strokeWidth={mark.forecastWidth}
        strokeLinecap="round"
        strokeDasharray={mark.forecastDash || undefined}
      />
      {mark.dot && <circle cx="33" cy="30" r="2.6" fill="currentColor" />}
    </svg>
  )
}

export function Wordmark({ className = '' }) {
  return (
    <span className={`inline-flex items-baseline tracking-[-0.03em] ${className}`}>
      <span className="font-normal">Finance</span>
      <span className="font-semibold">&nbsp;Prévision</span>
    </span>
  )
}

export default function Logo({
  size = 32,
  variant = 'auto',
  withWordmark = false,
  stacked = false,
  className = '',
  wordmarkClassName = '',
}) {
  const mark = (
    <Mark
      variant={variant}
      size={size}
      title={withWordmark ? undefined : 'Finance Prévision'}
      className="shrink-0 text-accent"
    />
  )

  if (!withWordmark) {
    return <span className={`inline-flex ${className}`}>{mark}</span>
  }

  return (
    <span
      className={`inline-flex items-center ${stacked ? 'flex-col gap-3' : 'gap-2.5'} ${className}`}
    >
      {mark}
      <Wordmark
        className={
          stacked
            ? `text-ink ${wordmarkClassName || 'text-2xl'}`
            : `text-ink ${wordmarkClassName}`
        }
      />
    </span>
  )
}
